import React from 'react';

/** Анимированный фон hero: волна цвета из верхнего левого в нижний правый угол */
const LandingHeroWaveBackground = () => (
  <div className="landing-hero-wave absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
    <div className="landing-hero-wave__base absolute inset-0" />
    <div className="landing-hero-wave__layer landing-hero-wave__layer--primary" />
    <div className="landing-hero-wave__layer landing-hero-wave__layer--secondary" />
    <div className="landing-hero-wave__layer landing-hero-wave__layer--accent" />
    <div className="landing-hero-wave__sheen" />
  </div>
);

export default LandingHeroWaveBackground;
